<template>
<div class="chapter">
<div class="inner_page">
<p class="chap"> </p>
<p class="center"><i>In memory of Dave Michalak,</i></p>
<p class="center"><i>in lieu of the Epic Poem of Foghat</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?5dcb2367